import { render, staticRenderFns } from "./CoDate.vue?vue&type=template&id=669c815e&"
import script from "./CoDate.vue?vue&type=script&lang=ts&"
export * from "./CoDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports